import { useNavigate, } from "react-router-dom";
import { useQuery, useQueryClient, } from "@tanstack/react-query";

import {
  userProfileQueryConfig,
  nationalitiesQueryConfig,
  userProfileDocumentsQueryConfig,
} from "../../../api";
import { RoutesMap, } from "../../../routes";
import { capitalize, formatDate, } from "../../../utils";
import { ProfilePageView, } from "./ProfilePageView.tsx";
import { usePersistStore, } from "../../../store/persistStore";

export function ProfilePageDefault() {
  const queryClient = useQueryClient();
  const userProfileQuery = useQuery({
    ...userProfileQueryConfig(),
    initialData: { id: 0, },
    refetchOnMount: "always",
  },);
  const useNationalitiesQuery = useQuery({
    ...nationalitiesQueryConfig(),
    select: data => data.find(({ id, },) => id === userProfileQuery.data.nationalityId,)?.name,
  },);
  const userDocumentsQuery = useQuery({
    ...userProfileDocumentsQueryConfig(),
  },);

  const navigate = useNavigate();
  const clearToken = usePersistStore(state => state.clearJwt,);
  const clearDeviceToken = usePersistStore(state => state.clearDeviceJwt,);

  const handleLogout = () => {
    clearToken();
    clearDeviceToken();
    queryClient.clear();
    navigate(RoutesMap.login.index,);
  };

  const fullName = userProfileQuery.data.name
    ? [
        userProfileQuery.data.surname!,
        userProfileQuery.data.name,
        userProfileQuery.data.patronymic!,
      ].filter(Boolean,).map(capitalize,).join(" ",)
    : "";
  const birthdate = userProfileQuery.data.birthdate
    ? formatDate(new Date(userProfileQuery.data.birthdate,), { year: "numeric", },)
    : "";
  const nationality = capitalize(useNationalitiesQuery.data ?? "",);
  const passportIssueDate = userProfileQuery.data.passportIssueDate
    ? formatDate(new Date(userProfileQuery.data.passportIssueDate,), { year: "numeric", },)
    : "";

  return (
    <ProfilePageView
      isFetching={userProfileQuery.isFetching && useNationalitiesQuery.isFetching}
      userData={{
        phone: userProfileQuery.data.phone,
        email: userProfileQuery.data.email,
        fullName: fullName,
        birthdate: birthdate,
        nationality: nationality,
        passportSeries: userProfileQuery.data.passportSeries,
        passportNumber: userProfileQuery.data.passportNumber,
        passportIssueDate: passportIssueDate,
        passportDivisionCode: userProfileQuery.data.passportDivisionCode ?? "",
        registrationAddressString: userProfileQuery.data.registrationAddressString ?? "",
      }}
      documents={{
        isFetching: userDocumentsQuery.isFetching,
        isSuccess: userDocumentsQuery.isSuccess && userDocumentsQuery.data.length > 0,
        isError: userDocumentsQuery.isError,
        data: userDocumentsQuery.data,
        refetch: userDocumentsQuery.refetch,
      }}
      handleLogout={handleLogout}
    />
  );
}
